var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1378_196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.299 32.3565L29.6305 26.6051V14.8895C29.6305 13.7115 28.6783 12.7593 27.5003 12.7593C26.3223 12.7593 25.3701 13.7115 25.3701 14.8895V27.6703C25.3701 28.3413 25.6854 28.974 26.2222 29.3744L34.7427 35.7649C35.1261 36.0524 35.5735 36.1909 36.0186 36.1909C36.6683 36.1909 37.3074 35.899 37.7249 35.3367C38.4323 34.3972 38.2405 33.0616 37.299 32.3565Z",
    fill: "#3C3E3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 0C12.3356 0 0 12.3356 0 27.5C0 42.6644 12.3356 55 27.5 55C42.6644 55 55 42.6644 55 27.5C55 12.3356 42.6644 0 27.5 0ZM27.5 50.7398C14.6873 50.7398 4.26024 40.3127 4.26024 27.5C4.26024 14.6873 14.6873 4.26024 27.5 4.26024C40.3149 4.26024 50.7398 14.6873 50.7398 27.5C50.7398 40.3127 40.3127 50.7398 27.5 50.7398Z",
    fill: "#3C3E3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1378_196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.eb9070fd392ba5f017598a6af7f31ba7.svg";
export { ForwardRef as ReactComponent };